export const ignoredClientErrorMessages = [
  /ResizeObserver loop/,
  /attempted to hard navigate/,
  /routeChange aborted/,
  /not authenticated/,
]

export const isWhitelistedClientError = (message: string) =>
  ignoredClientErrorMessages.some((msg) => message.match(msg))
